export const ids = ['job-file', 'fpc-job-file', 'transaction-file', 'project-file'] as const;
